import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { InternationalizationService } from "./services";
import { defaultLanguage, supportedLanguages } from "./constants";
import { I18N_CONFIG_PROVIDERS } from "./internationalization.config";

@NgModule({
  imports: [CommonModule],
  providers: [...I18N_CONFIG_PROVIDERS],
})
export class ClientsiteSharedInternationalizationDataAccessModule {
  constructor(private internationalizationService: InternationalizationService) {
    this.internationalizationService.init(
      supportedLanguages.map(supportedLanguage => supportedLanguage.code)
    );
  }
}
